export const ACCEPTED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
  'image/heic-sequence',
  'image/heif-sequence',
  'image/dng',
  'image/x-adobe-dng',
] as const;
export const ACCEPTED_IMAGE_INPUT_TYPES = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.heic',
  '.heif',
  '.dng',
  ...ACCEPTED_IMAGE_MIME_TYPES,
].join(',');
export const MAX_IMAGE_SIZE_BYTES = 30 * 1024 * 1024;

export type ImageValidationError = 'invalidType' | 'tooLarge';

export const isHeicImageFile = (file: File): boolean => {
  const type = file.type.toLowerCase();
  const name = file.name.toLowerCase();
  return type === 'image/heic'
    || type === 'image/heif'
    || type === 'image/heic-sequence'
    || type === 'image/heif-sequence'
    || name.endsWith('.heic')
    || name.endsWith('.heif');
};

export const isDngImageFile = (file: File): boolean => {
  const type = file.type.toLowerCase();
  return type === 'image/dng'
    || type === 'image/x-adobe-dng'
    || file.name.toLowerCase().endsWith('.dng');
};

export const validateImageFile = (file: File): ImageValidationError | null => {
  const hasAcceptedMimeType = ACCEPTED_IMAGE_MIME_TYPES.includes(
    file.type.toLowerCase() as typeof ACCEPTED_IMAGE_MIME_TYPES[number],
  );
  if (!hasAcceptedMimeType && !isHeicImageFile(file) && !isDngImageFile(file)) {
    return 'invalidType';
  }
  if (file.size > MAX_IMAGE_SIZE_BYTES) {
    return 'tooLarge';
  }
  return null;
};
